function FormatOrdinal(num: number): string {
    const integer = Math.round(num);
    const numString = num.toString();

    if (Math.floor(integer / 10) % 10 === 1) {
        return `${numString}th`;
    }

    switch (integer % 10) {
        case 1:
            return `${numString}st`;
        case 2:
            return `${numString}nd`;
        case 3:
            return `${numString}rd`;
        default:
            return `${numString}th`;
    }
}

export { FormatOrdinal };
